import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Menu, MenuItem, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../Components/Common Components/CommonComponents'
import { DataGrid } from "@mui/x-data-grid";
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom'
import { clearCachevalue, setCachevalue } from '../../Utility/Services/CacheProviderService';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import Loader from '../../Components/Loader';

const MrdHome = (props) => {
  const history = useHistory();
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [TransferList, setTransferList] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [CategoryList, setCategoryList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [selectedCategory, setselectedCategory] = useState(null);
  const [selectedLocation, setselectedLocation] = useState(null);
  const [selectedPatient, setselectedPatient] = useState(null);
  const [addDoc, setAddDoc] = useState(false);
  const [patientSearch, setPatientSearch] = useState(false);
  const [SearchKey, setSearchKey] = useState("");
  const [patientSearchList, setPatientSearchList] = useState([]);
  const [anchorEl, setanchorEl] = useState(null);

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }

  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  useEffect(() => {
    getLocationMaster()
    getCategoryMaster()
    clearCachevalue("MRDpatientDetails");
  }, [])

  useEffect(() => {
    getMRDHomeData()
  }, [selectedCategory, selectedLocation])

  const getCategoryMaster = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_CATEGORY_GET_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            let FilteredData = Data.filter(item => item.is_active === true)
            setCategoryList(FilteredData || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getLocationMaster = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_RACK_GET_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            let FilteredData = Data.filter(item => item.is_active === true)
            setLocationList(FilteredData || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getBarcode = (id = null) => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_BARCODE_GET + `?patient_id=${id}`)
        .then((response) => {
          if (response) {
            setisloader(false)
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getMRDHomeData = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_DOCUMENTS_ADD + `?category_id=${selectedCategory ? selectedCategory?.id : ''}&rack_id=${selectedLocation ? selectedLocation?.id : ''}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            Data = Data.map((item, index) => ({
              ...item,
              category_name_string : item.category_name ? (Array.isArray(item.category_name) ? item.category_name.join(', ') : item.category_name) : '-',
            }))
            setTransferList(Data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getPatientList = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${SearchKey}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || []
            if (Data.length > 0) {
              setPatientSearchList(Data || [])
              setPatientSearch(true)
            }
            else {
              errorMessage('No Records Found')
            }
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithExtraFilter />
          </Box>
        )
      }
      TransferList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'patient_name', headerName: 'Patient Details', flex: 0.13,
          renderCell: (params) => (<Box component={'div'}>{<CommonPatientDetails data={params?.row} />}</Box>
          ), valueGetter: (params) => {
            const name = params.row?.patient_name || "";
            const mobile = params.row?.patient_mobile_number || "";
            const UHID = params.row?.uhid || "";
            return `${name} ${mobile} ${UHID}`;
          }
        },
        {
          field: 'category_name_string', headerName: 'Category', flex: 0.14,
          renderCell: (params) => (params.row.category_name_string ? params.row.category_name_string?.length > 35 ?
            <Tooltip placement="top" title={params.row.category_name_string}><Typography>{params.row.category_name_string?.slice(0, 33) + '...'}</Typography></Tooltip> :
            <Typography>{params.row.category_name_string || '-'}</Typography> : '-')
        },
        {
          field: 'rack', headerName: 'Rack', flex: 0.10,
          renderCell: (params) => (params.row.rack ? params.row.rack?.length > 30 ?
            <Tooltip placement="top" title={params.row.rack}><Typography>{params.row.rack?.slice(0, 27) + '...'}</Typography></Tooltip> :
            <Typography>{params.row.rack || '-'}</Typography> : '-')
        },
        {
          field: 'last_visit_date', headerAlign: "center", headerName: 'Last Visited Date', align: "center", flex: 0.07, renderCell: (cellvalues) => {
            return (<Typography>{cellvalues.row.last_visit_date ? (cellvalues.row.last_visit_date).split("-").reverse().join("-") : "-"}</Typography>)
          }
        },
        {
          field: 'current_location', headerName: 'Current Location', flex: 0.10,
          renderCell: (params) => (params.row.current_location ? params.row.current_location?.length > 30 ?
            <Tooltip placement="top" title={params.row.current_location}><Typography>{params.row.current_location?.slice(0, 27) + '...'}</Typography></Tooltip> :
            <Typography>{params.row.current_location || '-'}</Typography> : '-')
        },
        {
          field: 'action', headerName: 'Action', headerAlign: "center", flex: 0.05, align: "center",
          renderCell: (params) => (<Box component={'div'}>
            <Tooltip title={"View Documents"} placement="top" arrow>
              <Button
                onClick={() => {
                  history.push({ pathname: "/MrdHome/PatientDetails/Documents", states: params.row })
                  setCachevalue(JSON.stringify(params.row), "MRDpatientDetails")
                }}
                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                <img src={ImagePaths.LabViewButton.default} alt="view" style={{ width: '1.5vw', height: '1.5vw' }} />
              </Button>
            </Tooltip>
            <Tooltip title={"Print BarCode"} placement="top" arrow>
              <Button
                onClick={() => { getBarcode(params?.row?.patient_id) }}
                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                <img src={ImagePaths.BarcodeBtn.default} alt="barcode" style={{ width: '1.5vw', height: '1.5vw' }} />
              </Button>
            </Tooltip>
          </Box>)
        },
      ];
      return (
        <Box sx={{ height: '72vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={TransferList || []}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  const addDocmentPopup = () => {
    return (
      <Dialog open={true} >
        <DialogTitle id="alert-dialog-title">{"Create New Document"}</DialogTitle>
        <DialogContent sx={{ padding: "2dvw", height: '21dvh', width: '29dvw', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
            <TextField
              size='small'
              autoComplete='off'
              placeholder={"Search Patient"}
              InputProps={{
                endAdornment: (<InputAdornment position="end">
                  {isloader ? (
                    <CircularProgress size={20} />
                  ) : (
                    <IconButton
                      onClick={() => {
                        if (SearchKey.trim() !== "" && SearchKey?.length > 2) {
                          getPatientList()
                        }
                      }}
                      emed_tid="Patient_name_search"
                      variant="contained"
                      size="small"
                      edge="end"
                    >
                      <SearchIcon color="primary" />
                    </IconButton>
                  )}
                </InputAdornment>
                )

              }}
              sx={{ width: '24vw' }}
              value={SearchKey || ""}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && SearchKey.trim() !== "" && SearchKey?.length > 2) {
                  getPatientList()
                }
              }}
              onChange={(e) => {
                setselectedPatient(null)
                setanchorEl(e.currentTarget)
                setSearchKey(e.target.value)
              }} />
            <Menu
              open={patientSearch}
              anchorEl={anchorEl}
              sx={{ marginTop: "6dvh", height: '44dvh' }}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              onClose={() => {
                setPatientSearch(false)
              }}
              elevation={1}
            >
              {
                patientSearchList.length > 0 ?
                  patientSearchList.map((list, index) => (
                    <MenuItem emed_tid="Patient_mobile_suggestions"
                      autoFocus={index === 0}
                      onClick={() => {
                        setSearchKey("")
                        setselectedPatient(list)
                        setPatientSearch(false)
                      }}
                      key={index}>
                      <Box><CommonPatientDetails data={list} /></Box>
                    </MenuItem>
                  )) : null
              }
            </Menu>
          </Box>
          <Box sx={{ padding: "1vw" }}>
            {selectedPatient ? <CommonPatientDetails data={selectedPatient} /> : null}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => {
            setAddDoc(false)
            setselectedPatient(null)
            setSearchKey("")
            setPatientSearch(false)
          }}>{"Close"}</Button>
          <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => {
            setselectedPatient(null)
            setSearchKey("")
            setPatientSearch(false)
          }}>{"Clear"}</Button>
          <Button variant='contained' disabled={selectedPatient === null || !props?.Access?.editAccess} size='small' className='eMed_Filter_Btns' onClick={() => {
            if (selectedPatient === null) {
              errorMessage("Please select a patient to add documents")
            } else {
              history.push({ pathname: "/MrdHome/PatientDetails/Documents", states: selectedPatient })
              setCachevalue(JSON.stringify(selectedPatient), 'MRDpatientDetails')
            }
          }}>{"Add Documents"}</Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
        <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} alignItems={'center'}>
          <Autocomplete
            // clearIcon
            size='small'
            options={CategoryList}
            sx={{ width: '20vw' }}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.category_name}
            value={selectedCategory}
            onChange={(e, value) => {
              setselectedCategory(value)
            }}
            renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Category"} />}
          />
          <Autocomplete
            // clearIcon
            size='small'
            sx={{ width: '20vw', marginLeft: '1vw' }}
            options={LocationList}
            getOptionLabel={(option) => typeof (option) === 'string' ? option : option.rack_name}
            value={selectedLocation}
            onChange={(e, value) => {
              setselectedLocation(value)
            }}
            renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Location"} />}
          />
        </Box>
        <Button
          size='small'
          onClick={() => { setAddDoc(true) }}
          sx={{ textTransform: "capitalize" }}
          disabled={!props?.Access?.editAccess}
          variant='contained'>
          Add Documents
        </Button>
      </Box>
      <Box>
        {tableView()}
      </Box>
      {addDoc ? addDocmentPopup() : null}
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  )
}

export default MrdHome